import { api } from '../lib/axios';

export interface SocialMedia {
  id: string;
  name: 'FACEBOOK' | 'INSTAGRAM' | 'TWITTER' | 'TIKTOK' | 'YOUTUBE' | 'LINKEDIN' | 'PINTEREST' | 'DISCORD' | 'OTHER';
  url: string;
  iconUrl: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export const socialMediaService = {
  async findAll(): Promise<SocialMedia[]> {
    const response = await api.get<SocialMedia[]>('/social-media/find-all');
    return response.data;
  }
}; 